import React from 'react';
import { AsyncPaginate } from 'react-select-async-paginate';
import { components as selectComponents } from 'react-select';
import PropTypes from 'prop-types';

// Custom Input to provide stable data-test-id for tests.
const PaginateInput = props => {
  const testId = props.selectProps?.['data-test-id'];
  return <selectComponents.Input {...props} data-test-id={testId} />;
};

/**
 * AsyncSelectPaginate wrapper providing stable data-test-id for tests.
 * dataTestId is optional; if omitted no data-test-id is applied.
 */
const AsyncSelectPaginate = ({
  dataTestId = undefined,
  components: userComponents = undefined,
  ...rest
}) => {
  const mergedComponents = userComponents
    ? { ...userComponents, Input: PaginateInput }
    : { Input: PaginateInput };
  return (
    <AsyncPaginate
      components={mergedComponents}
      data-test-id={dataTestId}
      {...rest}
    />
  );
};

AsyncSelectPaginate.propTypes = {
  dataTestId: PropTypes.string,
  components: PropTypes.object,
};

export default AsyncSelectPaginate;
